<template>
  <div class="fixed flex flex-col h-dscreen w-full bg-grey-00 left-0 top-0 py-5 px-4 z-40">
    <div class="flex justify-between items-center mb-4">
      <p class="text-h5 font-bold tracking-2 flex items-center">
        <slot name="title"></slot>
      </p>

      <icon-button @click="$emit('close')">
        <i class="fas fa-times m-auto text-xl leading-10" />
      </icon-button>
    </div>

    <div :class="`${allowOverflow ? 'overflow-y-auto' : 'overflow-y-hidden'} overflow-x-hidden flex-1`">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import IconButton from '../buttons/IconButton'

  export default {

    props: {
      allowOverflow: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        originalOverflowY: 'auto',
      }
    },

    mounted() {
      this.originalOverflowY = document.body.style.overflowY

      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    },

    beforeDestroy() {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = this.originalOverflowY
        document.documentElement.style.overflow = this.originalOverflowY
      }
    },

    components: { IconButton }

  }
</script>
